const en = {
    "Login": "Login",
};

export default en;